"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Image = _interopRequireDefault(require("../../Image"));
var _react = _interopRequireDefault(require("react"));
var _HitProvider = require("../provider/HitProvider");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HitImage = function HitImage(_ref) {
  var _ref$decreaseStyle = _ref.decreaseStyle,
    decreaseStyle = _ref$decreaseStyle === void 0 ? "red" : _ref$decreaseStyle;
  var _useHit = (0, _HitProvider.useHit)(),
    hitProduct = _useHit.hitProduct;
  if (!(hitProduct !== null && hitProduct !== void 0 && hitProduct.image)) {
    return null;
  }
  var colorStyles = decreaseStyle === "red" ? {
    color: "white",
    bg: "negative"
  } : {
    color: "negative",
    bg: "white"
  };
  var imageShadowColor = "88,122,148"; // bylo: "138,55,51"
  return __jsx(_Box["default"], {
    sx: {
      p: 10,
      position: "relative",
      zIndex: 1
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread({
      display: "flex",
      font: "sans_serif_22",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      zIndex: 2,
      right: [-25, null, null, 25],
      top: [-25, null, null, 25],
      width: 90,
      height: 90,
      borderRadius: 50
    }, colorStyles)
  }, "- ".concat(hitProduct.percentDecrease, "%")), __jsx(_Image["default"], {
    overlay: true,
    sx: {
      aspectRatio: 1.356,
      width: [250, null, null, 350],
      maxHeight: [250, null, null, 350],
      maxWidth: "100%",
      boxShadow: ["15px -15px 0px 0px rgba(".concat(imageShadowColor, ",1)"), null, null, "25px -25px 0px 0px rgba(".concat(imageShadowColor, ",1)")]
    },
    mode: "cover",
    image: hitProduct === null || hitProduct === void 0 ? void 0 : hitProduct.image,
    sizes: "(max-width: 678px) and (min-width: 10px) 210px, 420px",
    cloudflareEnabled: global.__appConfig__.smallImageCloudflareEnabled,
    quality: global.__appConfig__.smallImageQuality
  }));
};
var _default = HitImage;
exports["default"] = _default;